import { camelToCapitalizedConverter, } from './conversions/camelToCapitalized.js';
import { camelToKebabConverter, } from './conversions/camelToKebab.js';
import { camelToPascalConverter, } from './conversions/camelToPascal.js';
import { camelToSnakeConverter, } from './conversions/camelToSnake.js';
import { capitalizeConverter, } from './conversions/capitalize.js';
import { kebabToCamelConverter, } from './conversions/kebabToCamel.js';
import { kebabToCapitalizedConverter, } from './conversions/kebabToCapitalized.js';
import { kebabToPascalConverter, } from './conversions/kebabToPascal.js';
import { kebabToSnakeConverter, } from './conversions/kebabToSnake.js';
import { pascalToCamelConverter, } from './conversions/pascalToCamel.js';
import { pascalToCapitalizedConverter, } from './conversions/pascalToCapitalized.js';
import { pascalToKebabConverter, } from './conversions/pascalToKebab.js';
import { pascalToSnakeConverter, } from './conversions/pascalToSnake.js';
import { snakeToCamelConverter, } from './conversions/snakeToCamel.js';
import { snakeToCapitalizedConverter, } from './conversions/snakeToCapitalized.js';
import { snakeToKebabConverter, } from './conversions/snakeToKebab.js';
import { snakeToPascalConverter, } from './conversions/snakeToPascal.js';
import convert from './convert.js';
export const capitalize = (input) => convert(input, capitalizeConverter);
export const snakeToCamel = (input) => convert(input, snakeToCamelConverter);
export const snakeToKebab = (input) => convert(input, snakeToKebabConverter);
export const snakeToPascal = (input) => convert(input, snakeToPascalConverter);
export const snakeToCapitalized = (input) => convert(input, snakeToCapitalizedConverter);
export const kebabToCamel = (input) => convert(input, kebabToCamelConverter);
export const kebabToPascal = (input) => convert(input, kebabToPascalConverter);
export const kebabToSnake = (input) => convert(input, kebabToSnakeConverter);
export const camelToKebab = (input) => convert(input, camelToKebabConverter);
export const camelToSnake = (input) => convert(input, camelToSnakeConverter);
export const camelToCapitalized = (input) => convert(input, camelToCapitalizedConverter);
export const kebabToCapitalized = (input) => convert(input, kebabToCapitalizedConverter);
export const camelToPascal = (input) => convert(input, camelToPascalConverter);
export const pascalToKebab = (input) => convert(input, pascalToKebabConverter);
export const pascalToCamel = (input) => convert(input, pascalToCamelConverter);
export const pascalToCapitalized = (input) => convert(input, pascalToCapitalizedConverter);
export const pascalToSnake = (input) => convert(input, pascalToSnakeConverter);
//# sourceMappingURL=index.js.map